module.exports = __webpack_public_path__ + "static/media/ico-user.9129fd45.svg";